import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-condutor',
  templateUrl: './condutor.component.html',
  styleUrls: ['./condutor.component.css']
})
export class CondutorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
